<ng-template #content>
  @if (ctx; as ctx) {
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-clone text-primary me-2"></i>
        Clone issue
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>

    <div class="modal-body clone-issue-body">
      <div class="clone-issue-info mb-3">
        <h6 class="clone-title">Clone the issue of "{{ ctx.testTitle }}"</h6>
        <p class="clone-instruction text-muted">
          Select the checklist steps where this issue should be cloned.
        </p>
      </div>

      @if (ctx.isLoading) {
        <div class="clone-issue-placeholder text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mt-3 text-muted">Loading checklists...</div>
        </div>
      } @else if (ctx.loadError) {
        <div class="alert alert-danger mb-0">
          <i class="fa fa-exclamation-triangle me-2"></i>
          Error loading the checklists available for cloning.
        </div>
      } @else if (steps.length === 0) {
        <div class="alert alert-info mb-0">
          <i class="fa fa-info-circle me-2"></i>
          No checklist step is available for cloning this issue.
        </div>
      } @else {
        <label class="clone-row clone-select-all">
          <span class="clone-row-text fw-bold">Select all</span>
          <input class="clone-checkbox" type="checkbox"
            [checked]="areAllSelected()"
            [indeterminate]="areSomeSelected()"
            (change)="onToggleAll($event)">
        </label>

        <div class="clone-issue-list">
          @for (step of steps; track step.projectTestlistStepId) {
            <label class="clone-row clone-step">
              <span class="clone-row-text">
                @if (step.position) {
                  <span class="step-position">{{ step.position }}.</span>
                }
                <span class="step-text">{{ step.label }}</span>
                @if (step.issuesCount > 0) {
                  <span class="step-badge">
                    <i class="fa fa-exclamation-triangle me-1"></i>
                    {{ step.issuesCount }} issue{{ step.issuesCount === 1 ? '' : 's' }}
                  </span>
                }
              </span>
              <input class="clone-checkbox" type="checkbox"
                [checked]="isStepSelected(step)"
                (change)="onStepToggle(step, $event)">
            </label>
          }
        </div>
      }
    </div>

    <div class="modal-footer d-flex flex-wrap justify-content-between align-items-center gap-2">
      <span class="selected-counter text-muted">
        {{ selectedCount }} step{{ selectedCount === 1 ? '' : 's' }} selected
      </span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-secondary" [disabled]="ctx.isSaving" (click)="close()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary"
          [disabled]="!isValid() || ctx.isSaving || ctx.isLoading"
          (click)="confirm()">
          @if (ctx.isSaving) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          }
          Save
        </button>
      </div>
    </div>
  }
</ng-template>
